import React from 'react';

import MediaPoolCard from '../media-pool-card/MediaPoolCard';
import { getStoryMediaId } from '../../../../media/storyMediaItem';

import scss from './MediaPoolGrid.module.scss';

function MediaPoolGrid({ items, selectedIds, onSelect, onPreview }) {
  return (
    <div className={scss.wrapper}>
      {items.map((media) => (
        <MediaPoolCard
          key={media.id}
          media={media}
          isSelected={selectedIds.has(getStoryMediaId(media))}
          onSelect={onSelect}
          onPreview={onPreview}
        />
      ))}
    </div>
  );
}

export default MediaPoolGrid;
